import './App.css';
import SearchDoctor from "./SearchDoctor";
import {useEffect, useState} from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Login from "./Login";
import Forgot from "./Forgot";
import Reset from "./Reset";
import DashBoard from "./DashBoard";
import {Provider} from "react-redux";
import store from "./redux/store";
import Register from "./Register";
import {ToastContainer} from "react-toastify";
import ProfileSettings from "./ProfileSettings";
import PasswordChange from "./PasswordChange";
import Contact from "./Contact";
import DoctorsByDeparments from "./DoctorsByDeparments";
import MyMapComponent from "./MyMapComponent";
import OpenLocation from "./OpenLocation";
import UserManage from "./UserManage";

function App() {
  return (

    <BrowserRouter basename={""}>
      <PageSwitcher />
    </BrowserRouter>
  );
}
function NoMatch() {
  let location = useLocation();

  return (
    <div>
      <h3>
        Sayfa bulunamadı <code>{location.pathname}</code>
      </h3>
    </div>
  );
}
function PageSwitcher() {
  const location = useLocation();
  const [key, setKey] = useState(Date.now());

  useEffect(() => {
    // Sayfa değiştiğinde key'i güncelle
    setKey(Date.now());
  }, [location.pathname]);

  return (


   <>
     <Provider store={store}>
      <Routes>
        <Route path="" element={<SearchDoctor key={key} />} />
          <Route path="/main" element={<SearchDoctor key={key} />} />
          <Route path="/login" element={<Login key={key} />} />
          <Route path="/user-manage" element={<UserManage key={key} />} />

          <Route path="/register" element={<Register key={key} />} />
        <Route path="/forgot-password" element={<Forgot key={key} />} />
        <Route path="/reset-password/:reset_code" element={<Reset key={key} />} />
        <Route path="/doctor/dashboard" element={<DashBoard key={key} />} />
        <Route path="/doctor/profile-settings" element={<ProfileSettings key={key} />} />
        <Route path="/doctor/password-change" element={<PasswordChange key={key} />} />
          <Route path="/doctor-list/:department" element={<DoctorsByDeparments key={key} />} />

          <Route path="/contact" element={<Contact key={key} />} />
          <Route path="/test" element={<MyMapComponent key={key} />} />
        <Route path="*" element={<NoMatch key={key} />} />
      </Routes>
     </Provider>
     <ToastContainer />
    </>

  );
}
export default App;
